// removed by extract-text-webpack-plugin
module.exports = {"Card":"J4rBbYugzB8oJNgDHag-D","Body":"_2bj5z14wK9d9WkfCY12iEV","Footer":"_3rKbNF7x3kZQnwBsl0QE3J","Title":"_5ULabzMsiXvyri6BUguZw","Group":"evb4GrbP5XY0jAC38KtFJ","Column":"_2Alt0Ge8oHh6nFG0Lwd-M_","Input":"_3UAiL5jBEXAjesZKdwEdDH"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/PayoutsDetailEditing/styles.module.css
// module id = 563
// module chunks = 0